import coreAPI from 'apis/core';

export const getChainCommissions = async (chain) => {
  const DEFAULT_NON_REFERRED_CONSULTATION_FEE_CAP = 30;
  const DEFAULT_APPOINTMENT_COMMISSION_RATE_PERCENTAGE = 0.05;
  const DEFAULT_NON_REFERRED_CONSULTATION_FEE = 0.75;
  const DEFAULT_TEXT_ALERTS = 0.05;
  const DEFAULT_SITE_CAP = 65;
  const DEFAULT_APPOINTMENT_REFUND_COMMISSION_RATE_PERCENTAGE = 0.03;

  const { data: [globalCommissions] = [] } =
    (await coreAPI.configuration.getConfiguration('global_commissions')) || {};

  if (!globalCommissions) throw new Error('Error while fetching commissions');

  const chainCommissions = chain?.commissions?.defaultRate || {};
  const siteCap = chainCommissions.site_cap || globalCommissions.site_cap || DEFAULT_SITE_CAP;
  const nonReferredConsultationFeeCap =
    chainCommissions.non_referred_consultation_fee_cap ||
    globalCommissions.non_referred_consultation_fee_cap ||
    DEFAULT_NON_REFERRED_CONSULTATION_FEE_CAP;
  const appointmentCommissionRatePercentage =
    chainCommissions.appointment_commission_rate_percentage ||
    globalCommissions.appointment_commission_rate_percentage ||
    DEFAULT_APPOINTMENT_COMMISSION_RATE_PERCENTAGE;
  const nonReferredConsultationFee =
    chainCommissions.non_referred_consultation_fee ||
    globalCommissions.non_referred_consultation_fee ||
    DEFAULT_NON_REFERRED_CONSULTATION_FEE;
  const textAlerts =
    chainCommissions.text_alerts || globalCommissions.text_alerts || DEFAULT_TEXT_ALERTS;
  const appointmentRefundCommissionRatePercentage =
    chainCommissions.appointment_refund_commission_rate_percentage ||
    globalCommissions.appointment_refund_commission_rate_percentage ||
    DEFAULT_APPOINTMENT_REFUND_COMMISSION_RATE_PERCENTAGE;

  return {
    minimumChargeThreshold:
      chainCommissions.minimum_charge_threshold || globalCommissions.minimum_charge_threshold,
    nonReferredItemCommission:
      chainCommissions.non_referred_item || globalCommissions.non_referred_item,
    siteCap,
    nonReferredConsultationFeeCap,
    appointmentCommissionRatePercentage,
    nonReferredConsultationFee,
    textAlerts,
    appointmentRefundCommissionRatePercentage,
  };
};

export const getServiceConfigurations = async (key = 'services_configurations') => {
  const response = await coreAPI.configuration.getGenericConfiguration(key);

  return response.data[0];
};

export default {};
